<template>
  <div>
  <AppHeaderDropdown right no-caret>
    <template slot="header"> 
      <!-- <b><b-img rounded="circle" :src="user.perfil.image" width="30" height="30" alt="img" class="m-1" /></i> {{'  ' + user.username + ' '}} <i class="fa fa-circle text-success"></i></b> -->
      <b><i class="fa fa-user text-dark margenizq"/> {{'  ' + user.username + ' '}} <i class="fa fa-circle text-success"/></b>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Usuario</strong>
      </b-dropdown-header>
      <b-dropdown-item  to="/panel"><i class="fa fa-user" /> Opciones</b-dropdown-item>
      <!-- <b-dropdown-item to="/user"><i class="fa fa-user" /> Perfil</b-dropdown-item>
      <b-dropdown-item v-if="user.rol=='Admin'" to="/settings"><i class="fa fa-wrench" /> Opciones</b-dropdown-item> -->
      <b-dropdown-item @click="showlogoutModal()"><i class="fa fa-sign-out" /> Salir</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
    <b-modal centered v-model="logout">
      <template slot="modal-header">
        <h5 class="modal-title">Salir del Sistema</h5>
      </template>
      <p><b>{{ user.username }}</b> desea salir del sistema?</p>
      <template slot="modal-footer">
        <b-button variant="secondary" class="btn btn-secondary" @click="logout=false">Cancelar</b-button>
        <b-button variant="danger" class="btn btn-primary" @click="logoutUser">Salir</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  mounted(){
    this.getUserData();
  },
  data: () => {
    return {
      user: {
          cuenta:{
            razonsocial:''
          },
          perfil:{
            image:''
          }
        },
        token: '',
        logout: false
      }
  },
  methods: {
      getUserData: function() {
        this.user = this.$store.getters.userData;
        this.token = this.$store.getters.userToken
      },
    showlogoutModal: function() {
      this.logout = true
    },
    logoutUser: function() {
      this.$store.commit('logoutuser');
      this.$router.push('/login')//.catch(err => {})
    }
  }
}
</script>
<style scoped>
.app-header .nav-item button {
  margin: 0 !important;
}
.margenizq{
  margin-left: 20px;
}
</style>
